import { recipe } from "@vanilla-extract/recipes";
import { keyframes, style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { transition } from "@huub-web/ui/utils/transition";

import { theme } from "@huub-web/ui/theme/css/theme.css";

const pulsateAnimation = keyframes({
  "0%": {
    transform: "scale(1)",
    opacity: 0,
  },
  "25%": {
    opacity: 0.25,
  },
  "75%": {
    transform: "scale(1.3)",
    opacity: 0,
  },
  "100%": {
    transform: "scale(1)",
    opacity: 0,
  },
});

export const hotspotStyle = recipe({
  base: {
    transformOrigin: "center center",
    borderRadius: "50%",
    backgroundColor: theme.colors.info,
    position: "absolute",
    zIndex: 3,
    width: 0,
    height: 0,
    selectors: {
      "&:after": {
        content: "",
        position: "absolute",
        backgroundColor: theme.colors.info,
        borderRadius: "50%",
        transition: transition("background-color"),
      },
      "&:before": {
        content: "",
        position: "absolute",
        borderRadius: "50%",
        backgroundColor: theme.colors.info,
        opacity: 0.25,
        animation: `${pulsateAnimation} 2s ease-in-out infinite`,
        transition: transition("background-color"),
      },
    },
  },
  variants: {
    hoverable: {
      true: {
        pointerEvents: "auto",
        cursor: "pointer",
        selectors: {
          "&:hover:before": {
            backgroundColor: theme.colors.infoHover,
          },
          "&:hover:after": {
            backgroundColor: theme.colors.infoHover,
          },
        },
      },
    },
    type: {
      marker: {},
      dot: {},
    },
    size: {
      xs: {
        ":after": {
          width: rem(12),
          height: rem(12),
          top: rem(-6),
          left: rem(-6),
        },
        "&:before": {
          width: rem(24),
          height: rem(24),
          top: rem(-12),
          left: rem(-12),
        },
      },
      s: {
        ":after": {
          width: rem(20),
          height: rem(20),
          top: rem(-10),
          left: rem(-10),
        },
        "&:before": {
          width: rem(32),
          height: rem(32),
          top: rem(-16),
          left: rem(-16),
        },
      },
    },
  },
  defaultVariants: {
    size: "s",
  },
});

export const hotspotCardStyle = recipe({
  base: {
    width: rem(252),
    position: "absolute",
    bottom: `calc(100% + ${theme.spacings.m})`,
    left: "50%",
    transform: "translateX(-50%)",
  },
  variants: {
    closable: {
      true: {
        width: rem(300),
      },
    },
  },
});

export const closeStyle = recipe({
  base: {
    alignSelf: "flex-start",
  },
});

export const hotspotTitleStyle = style({
  lineHeight: 1.2,
});
